import MuiList from "./list";
import MuiCard from "./card";
import MuiAvatar from "./avatars";
import MuiInput from "./input";
import MuiDataGrid from "./dataGrid";

const Overrides = (theme, settings) => {
  const { skin } = settings;
  const list = MuiList(theme);
  const avatars = MuiAvatar(theme);
  const input = MuiInput(theme);
  const cards = MuiCard(theme, skin);
  const dataGrid = MuiDataGrid(theme);

  return Object.assign(list, avatars, cards, input, dataGrid);
};

export default Overrides;
